import React from 'react';
import PropTypes from 'prop-types';
import CustomPropTypes from 'CustomPropTypes';
import * as ReactRedux from 'react-redux';
import { bindActionCreators } from 'redux';
import withHover from 'WithHover';
import { setPopupCreationError } from 'SelfServeBuilder/SelfServeBuilderActions';
import { SelfServeBuilderPopupTypes, toolboxItemTypeToTracking } from 'Popups';
import * as TooltipTourActions from 'SelfServeTooltipTour/TooltipTourActions';
import ToolItemTooltip from './ToolItemTooltip';
import * as SelfServeBuilderToolboxActions from './SelfServeBuilderToolboxActions';

export class ToolItem extends React.PureComponent {
  constructor(props) {
    super(props);

    this.onClick = this.onClick.bind(this);
  }

  componentDidMount() {
    const rect = this.props.toolboxRef.current.getBoundingClientRect();
    this.props.setTooltipLocation(rect, this.props.tooltipName);
  }

  onClick() {
    window._track(`${toolboxItemTypeToTracking[this.props.type]} | Toolbar`, 'Template Builder');
    const {
      popupCreationEnabled,
      activePopup,
      isEditingGroup,
      tooltipInfo,
      tooltipName,
    } = this.props;
    const noActivePopup = !activePopup || activePopup.length === null;
    const notCreatingGroup = popupCreationEnabled && !isEditingGroup;
    const { isSeen } = tooltipInfo[tooltipName];
    if (noActivePopup || notCreatingGroup) {
      this.props.setActiveToolboxToolItem(this.props.type);
      if (!isSeen && !this.props.isToolboxTourHidden) {
        this.props.showToolboxTip(this.props.tooltipName);
      } else {
        this.props.hideCurrentToolboxTip(this.props.tooltipName);
      }
    } else {
      this.props.setPopupCreationError();
    }
  }

  render() {
    const isActive = this.props.activeToolboxItem === this.props.type;
    const imgSrc = this.props.isHover || isActive ? this.props.imgSrcHover : this.props.imgSrc;

    return (
      <div
        className="tool-item-container"
        data-class={`tool-item-tooltip ${this.props.tooltipClassName}`}
        data-delay-hide="50"
        data-for={this.props.type}
        data-tip
        ref={this.props.toolboxRef}
      >
        <button
          className={`tool-item-button ${isActive ? 'active' : ''}`}
          onClick={this.onClick}
          onMouseOut={this.props.onMouseOut}
          onMouseOver={this.props.onMouseOver}
        >
          <div className="tool-item-img-container">
            <img
              alt=""
              className="tool-item-img"
              src={imgSrc}
            />
          </div>
          <div className="tool-item-title">
            {this.props.title}
          </div>
          <div className="tool-item-description">
            {this.props.description}
          </div>
        </button>

        <ToolItemTooltip
          className={this.props.tooltipClassName}
          description={this.props.tooltipDescription}
          example={this.props.tooltipExample}
          id={this.props.type}
          title={this.props.title}
        />
      </div>
    );
  }
}

ToolItem.defaultProps = {
  activePopup: '',
  activeToolboxItem: '',
  hideCurrentToolboxTip: () => null,
  setTooltipLocation: () => null,
  showToolboxTip: () => null,
  tooltipClassName: '',
};

ToolItem.propTypes = {
  activePopup: PropTypes.string,
  activeToolboxItem: PropTypes.oneOf(
    Object.values(SelfServeBuilderPopupTypes),
  ).isRequired,
  description: PropTypes.node.isRequired,
  hideCurrentToolboxTip: PropTypes.func,
  imgSrc: PropTypes.string.isRequired,
  imgSrcHover: PropTypes.string.isRequired,
  isEditingGroup: PropTypes.bool.isRequired,
  isHover: PropTypes.bool.isRequired,
  onMouseOut: PropTypes.func.isRequired,
  onMouseOver: PropTypes.func.isRequired,
  popupCreationEnabled: PropTypes.bool.isRequired,
  setActiveToolboxToolItem: PropTypes.func.isRequired,
  setPopupCreationError: PropTypes.func.isRequired,
  setTooltipLocation: PropTypes.func,
  showToolboxTip: PropTypes.func,
  title: PropTypes.string.isRequired,
  toolboxRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }).isRequired,
  isToolboxTourHidden: PropTypes.bool.isRequired,
  tooltipClassName: PropTypes.string,
  tooltipDescription: PropTypes.node.isRequired,
  tooltipExample: PropTypes.node.isRequired,
  tooltipInfo: CustomPropTypes.hashmapOf(
    PropTypes.shape({
      tipOutlineRectangle: PropTypes.shape({
        bottom: PropTypes.number,
        height: PropTypes.number,
        left: PropTypes.number,
        right: PropTypes.number,
        top: PropTypes.number,
        width: PropTypes.number,
        x: PropTypes.number,
        y: PropTypes.number,
      }),
      isSeen: PropTypes.bool,
    }).isRequired,
  ).isRequired,
  tooltipName: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

const mapStateToProps = ({
  popupHandler,
  SelfServeBuilderToolboxReducer,
  SelfServeBuilderReducer,
  ToolboxTooltipTourReducer,
  PopupGroupReducer,
}) => (
  {
    activePopup: popupHandler.activePopup,
    activeToolboxItem: SelfServeBuilderToolboxReducer.activeToolboxItem,
    popupCreationEnabled: SelfServeBuilderReducer.popupCreationEnabled,
    tooltipInfo: ToolboxTooltipTourReducer.tooltipInfo,
    isToolboxTourHidden: ToolboxTooltipTourReducer.isToolboxTourHidden,
    isEditingGroup: PopupGroupReducer.isEditingGroup,
  }
);

const mapDispatchToProps = dispatch => (
  bindActionCreators({
    ...SelfServeBuilderToolboxActions,
    setPopupCreationError,
    setTooltipLocation: TooltipTourActions.setTooltipLocation,
    showToolboxTip: TooltipTourActions.showToolboxTip,
    hideCurrentToolboxTip: TooltipTourActions.hideCurrentToolboxTip,
  }, dispatch)
);

const ToolItemWithRedux = ReactRedux.connect(
  mapStateToProps,
  mapDispatchToProps,
)(ToolItem);

export default withHover(ToolItemWithRedux);



// WEBPACK FOOTER //
// ./src-react/SelfServeBuilderToolbox/ToolItem.jsx